<template>
  <v-dialog v-model="dialog" scrollable max-width="900px" width="100%">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="light-blue" class="mr-2" dark v-bind="attrs" v-on="on">{{
        $t("SelectTerms")
      }}</v-btn>
    </template>
    <v-form ref="form" v-model="valid" @submit.prevent="submit" lazy-validation>
      <v-card>
        <v-card-title class="light-blue darken-4 white--text"
          >{{ $t("SearchTerms") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-alert dense outlined type="error" v-if="error">
          <ul>
            <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
          </ul>
        </v-alert>
        <v-card-text style="max-height: 70vh">
          <v-row>
            <v-col cols="8" md="5" offset-md="2">
              <v-text-field
                type="text"
                outlined
                v-model="title"
                :rules="reqRules"
                v-bind:label="$t('SearchTerms')"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="2" md="3">
              <v-btn color="light-blue" height="41px" block dark type="submit">
                {{ $t("Search") }}
              </v-btn>
            </v-col>
            <v-col cols="2" md="2">
              <v-btn
                color="light-blue"
                height="41px"
                block
                dark
                @click="reset()"
              >
                {{ $t("Reset") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-list-item three-line v-for="terms in termslist" :key="terms._id">
            <v-list-item-content>
              <v-list-item-title>{{ terms.title }}</v-list-item-title>
              <v-list-item-subtitle v-html="terms.description">{{
                terms.description
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn color="light-blue" dark small @click="selectTerm(terms)">
                {{ $t("Select") }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-btn color="red" text @click="dialog = false">
            {{ $t("Close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import PartnerService from "@/services/PartnerService";
import swal from "sweetalert";

export default {
  name: "SelectTermsComponent",
  components: {},
  data() {
    return {
      parm: this.$route.params.id,
      termslist: [],
      dialog: false,
      valid: null,
      error: null,
      title: "",
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  created: function() {
    PartnerService.getTerms({ property_id: this.parm })
      .then(result => {
        this.termslist = result.data.contractterms;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        PartnerService.searchContractTerms({ term: this.title })
          .then(result => {
            this.termslist = result.data.contract;
            this.loading = false;
          })
          .catch(err => {
            this.error = err.response.data.error;
          });
      }
    },
    reset() {
      this.loading = true;
      PartnerService.getTerms({ property_id: this.parm })
        .then(result => {
          this.termslist = result.data.contractterms;
          this.title = "";
          this.$refs.form.reset();
          this.loading = false;
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    },
    selectTerm(val) {
      this.waitDialog = true;
      val.property_id = this.parm;
      val.penalty = 0;
      PartnerService.addContractTerms(val)
        .then(() => {
          this.$emit("getContract");
          this.waitDialog = false;
          this.dialog = false;
        })
        .catch(err => {
          this.waitDialog = false;
          console.log(err.response.data);
          swal({
            icon: "error",
            text: err.response.data.errors[0].msg,
            button: {
              text: this.$t("Close"),
              className: "swal-close"
            }
          });
          //this.error = err.response.data.errors;
        });
    }
  }
};
</script>

<style scoped>
.v-dialog__content.v-dialog__content--active {
  z-index: 5000 !important;
}
</style>
